module.exports = __webpack_public_path__ + "img/rightbefore.a8c82ff8.png";